var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18834 5.12773C7.75636 3.80038 9.78471 3 12 3C16.9706 3 21 7.02944 21 12C21 14.2153 20.1996 16.2436 18.8723 17.8117L6.18834 5.12773ZM5.12769 6.18839C3.80036 7.7564 3 9.78473 3 12C3 16.9706 7.02944 21 12 21C14.2153 21 16.2436 20.1996 17.8116 18.8723L5.12769 6.18839ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slash.dacfbf64bd14ba58caa0bdbf0d57b158.svg";